import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const VocabularyWordSchema = BaseSchema.extend({
  key: z.string().max(255),
  value: z.string().max(255),
  visible: z.boolean().optional(),
  vocabularyGroup: z.string().max(255)
});

export type VocabularyWord = z.infer<typeof VocabularyWordSchema>;

export const WordSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export type Word = z.infer<typeof WordSchema>;

export const VocabularyWordEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: VocabularyWordSchema,
});

export type VocabularyWordEntityQueryResult = z.infer<typeof VocabularyWordEntityQueryResultSchema>;
